import { render, staticRenderFns } from "./TimeSlotDuration.vue?vue&type=template&id=0c67e9e6&"
import script from "./TimeSlotDuration.vue?vue&type=script&lang=js&"
export * from "./TimeSlotDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports